import { apiRequest } from 'utils/request'
import * as applicationActions from 'actions/application.js'
import { FLEET, NOTIFICATION_ERROR } from 'utils/constants'
import strings from 'utils/strings'

export const CREATE_SEARCH_STATE = 'CREATE_SEARCH_STATE'
export function createSearchState(resource) {
  return {
    resource,
    type: CREATE_SEARCH_STATE,
  }
}

export const SET_RESOURCE_TYPE = 'SET_RESOURCE_TYPE'
export function setResourceType(resourceType, resource) {
  return {
    resource,
    resourceType,
    type: SET_RESOURCE_TYPE,
  }
}
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING'
export function updateSearchString(searchString, resource) {
  return {
    resource,
    searchString,
    type: UPDATE_SEARCH_STRING,
  }
}

export const SET_SUBMITTED_RESOURCE_TYPE = 'SET_SUBMITTED_RESOURCE_TYPE'
export function setSubmittedResourceType(resourceType, resource) {
  return {
    resource,
    resourceType,
    type: SET_SUBMITTED_RESOURCE_TYPE,
  }
}

export const SET_SUBMITTED_SEARCH_STRING = 'SET_SUBMITTED_SEARCH_STRING'
export function setSubmittedSearchString(searchString, resource) {
  return {
    resource,
    searchString,
    type: SET_SUBMITTED_SEARCH_STRING,
  }
}

export const SET_TABLE_MESSAGE = 'SET_TABLE_MESSAGE'
export function setTableMessage(message, resource) {
  return {
    resource,
    message,
    type: SET_TABLE_MESSAGE,
  }
}

export const SET_TABLE_BUTTON = 'SET_TABLE_BUTTON'
export function setTableButton(opts, resource) {
  return {
    ...opts,
    resource,
    type: SET_TABLE_BUTTON,
  }
}

export const SET_SELECTOR_STATE = 'SET_SELECTOR_STATE'
export function setSelectorState({ disabled }, resource) {
  return {
    disabled,
    resource,
    type: SET_SELECTOR_STATE,
  }
}

export const SET_PROPERTIES = 'SET_PROPERTIES'
export function setProperties(properties, resource) {
  return {
    properties,
    resource,
    type: SET_PROPERTIES,
  }
}

export const CLEAR_PROPERTIES = 'CLEAR_PROPERTIES'
export function clearProperties(resource) {
  return {
    resource,
    type: CLEAR_PROPERTIES,
  }
}

export const SET_FILTERS = 'SET_FILTERS'
export function setFilters(filters, resource) {
  return {
    filters,
    resource,
    type: SET_FILTERS,
  }
}
export const SET_SORT_STATE = 'SET_SORT_STATE'
export const setSortState = (columnId, keepPreviousSorts, resource) => ({
  columnId,
  keepPreviousSorts,
  resource,
  type: SET_SORT_STATE,
})

export const POPULATE_SEARCH_RESULTS = 'POPULATE_SEARCH_RESULTS'
export const populateSearchResults = (results, resource) => ({
  results,
  resource,
  type: POPULATE_SEARCH_RESULTS,
})

export const TOGGLE_SEARCH_RESULT_SELECTED = 'TOGGLE_SEARCH_RESULT_SELECTED'
export const toggleSearchResultSelected = (index, resource) => ({
  index,
  resource,
  type: TOGGLE_SEARCH_RESULT_SELECTED,
})

export const TOGGLE_SEARCH_RESULT_COMPARE = 'TOGGLE_SEARCH_RESULT_COMPARE'
export const toggleSearchResultCompare = (serialNumber, resource) => ({
  serialNumber,
  resource,
  type: TOGGLE_SEARCH_RESULT_COMPARE,
})

export const CLEAR_SEARCH_RESULT_SELECTED = 'CLEAR_SEARCH_RESULT_SELECTED'
export const clearSearchResultsSelected = (resource) => ({
  resource,
  type: CLEAR_SEARCH_RESULT_SELECTED,
})

export const CLEAR_SELECTED_KEYS = 'CLEAR_SELECTED_KEYS'
export const clearSelectedKeys = (resource) => ({
  resource,
  type: CLEAR_SELECTED_KEYS,
})

export const TOGGLE_SEARCH_RESULT_EXPANDED = 'TOGGLE_SEARCH_RESULT_EXPANDED'
export const toggleSearchResultExpanded = (index, resource) => ({
  index,
  resource,
  type: TOGGLE_SEARCH_RESULT_EXPANDED,
})

export const TOGGLE_SEARCH_RESULT_SELECTED_WITH_SELECTION_KEYS =
  'TOGGLE_SEARCH_RESULT_SELECTED_WITH_SELECTION_KEYS'
export const toggleSearchResultSelectedWithSelectionKeys = (
  record,
  resource,
  singleSelect = false
) => ({
  record,
  resource,
  singleSelect,
  type: TOGGLE_SEARCH_RESULT_SELECTED_WITH_SELECTION_KEYS,
})

export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS'
export const clearSearchResults = (resource, textPersist) => ({
  resource,
  textPersist,
  type: CLEAR_SEARCH_RESULTS,
})

export const REQUESTING_INITIAL_SEARCH_RESULTS =
  'REQUESTING_INITIAL_SEARCH_RESULTS'
function requestingInitialSearchResults(resource) {
  return {
    resource,
    type: REQUESTING_INITIAL_SEARCH_RESULTS,
  }
}

export const INITIAL_SEARCH_RESULTS_RECEIVED = 'INITIAL_SEARCH_RESULTS_RECEIVED'
function initialSearchResultsReceived(response, resource) {
  return {
    resource,
    type: INITIAL_SEARCH_RESULTS_RECEIVED,
    result: response.result,
    data: response.data,
    totalResults: response.data.total,
    startIndex: response.startIndex,
  }
}

export const INITIAL_SEARCH_RESULTS_NOT_RECEIVED =
  'INITIAL_SEARCH_RESULTS_NOT_RECEIVED'
function noInitialSearchResultsReceived(message, resource) {
  return {
    resource,
    type: INITIAL_SEARCH_RESULTS_NOT_RECEIVED,
    error: message,
  }
}

// When search results are first requested after entering a query, this action is dispatched
export const requestInitialSearchResults =
  (uri, resource, requestBody = null) =>
  (dispatch) => {
    dispatch(requestingInitialSearchResults(resource))

    const startIndex = requestBody && (requestBody.startIndex || null)

    return apiRequest({
      uri,
      method: resource === FLEET ? 'GET' : 'POST',
      body: requestBody,
    })
      .then((response) => {
        dispatch(
          initialSearchResultsReceived({ ...response, startIndex }, resource)
        )
      })
      .catch((err) => {
        dispatch(noInitialSearchResultsReceived(err.message, resource))
        dispatch(
          applicationActions.createSystemNotification({
            notificationMessage: strings.search_error,
            notificationType: NOTIFICATION_ERROR,
          })
        )
      })
  }

export const TOGGLE_SELECTED_ROW = 'TOGGLE_SELECTED_ROW'
export const toggleSelectedRow = (record, resource, idKeyName = 'id') => ({
  type: TOGGLE_SELECTED_ROW,
  record,
  idKeyName,
  resource,
})

export const SET_UNSELECTED_ITEMS_SELECTABLE = 'SET_UNSELECTED_ITEMS_SELECTABLE'
export const setSelectabilityOfUnselectedItems = (selectable, resource) => ({
  type: SET_UNSELECTED_ITEMS_SELECTABLE,
  disabled: !selectable,
  resource,
})

export const SET_UNSELECTED_ITEMS_SELECTABLE_SEARCHED_VEHICLES =
  'SET_UNSELECTED_ITEMS_SELECTABLE_SEARCHED_VEHICLES'
export const setSelectabilityOfUnselectedSearchedVehicles = (
  selectable,
  resource
) => ({
  type: SET_UNSELECTED_ITEMS_SELECTABLE_SEARCHED_VEHICLES,
  disabled: !selectable,
  resource,
})

export const SET_CLEAR_SEARCHED_VEHICLES_COMPARE =
  'SET_CLEAR_SEARCHED_VEHICLES_COMPARE'
export const setClearSearchedVehicleCompare = (resource) => ({
  type: SET_CLEAR_SEARCHED_VEHICLES_COMPARE,
  resource,
})

export const UPDATE_SEARCH_RESULT_ITEM = 'DEPRECATED_UPDATE_SEARCH_RESULT_ITEM'
export const updateSearchResultItem = (resource, itemId, updatedData) => ({
  type: UPDATE_SEARCH_RESULT_ITEM,
  resource,
  itemId,
  updatedData,
})
